import React from 'react';
import RadioButton from './RadioButton.jsx';

export default function CheckBoxSelector(props) {
  const id = props.id || 'input-' + props.name;
  const label = props.label || props.name;
  const options = props.options || [];
  const value = props.value;
  const onChange = function (e) {
    const newValue = e.target.value;
    if (props.onChange) {
      props.onChange({name: props.name, value: newValue});
    } else console.log(props.name, newValue);
  };
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const optionBoxStyle = {
    padding: '0px 10px',
    marginBottom: 0,
    backgroundColor: props.backgroundColor || '#fff',
  };
  return (
    <div className = {formGroupClassName}>
    <label>{label}</label>
    <div id={id} className="well" style={optionBoxStyle}>
      {options.map((option, key) => {
        const radioButtonProps = {
          label: option.name,
          name: props.name,
          value: option.value,
          checked: (option.value === value),
          onChange,
          key,
        };
        return (<RadioButton {...radioButtonProps} />);
      })}
    </div>
    <span className="help-block">{props.error || props.message}</span>
  </div>);
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/RadioButtonSelector.jsx